// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"5daf04a8","190":"b46abac3","453":"fefd54e9","511":"d8d1f88f","571":"2d311058","800":"48395446","815":"423d5d68","875":"548a0da1"}[chunkId] + ".chunk.js";
};